"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var const_1 = require("../../const");
var util_1 = require("../../libs/util");
var drop_cursor_view_1 = require("./drop-cursor-view");
var shouldInsertParagraph = function (child) {
    // notLastLine 用来表明不能在文档最后一行
    if (!child || child.type.spec.notLastLine)
        return true;
    var lastChild = child;
    while (lastChild) {
        if (!lastChild.lastChild)
            break;
        lastChild = lastChild.lastChild;
    }
    return !lastChild.isTextblock || Boolean(lastChild.content.size);
};
var BasicView = /** @class */ (function () {
    function BasicView(view, config) {
        this.config = config;
        if (config.dropCursor !== false) {
            this.dropCursor = new drop_cursor_view_1.DropCursorView(view, typeof config.dropCursor !== 'object' ? undefined : config.dropCursor);
        }
    }
    BasicView.prototype.update = function (view, prevState) {
        this.dropCursor && this.dropCursor.update(view, prevState);
        var state = view.state, _a = view.state, doc = _a.doc, tr = _a.tr, dispatch = view.dispatch;
        var lastChild = doc.lastChild;
        // lastChild为atom时即使keepLastLine为false也会增加行
        // TODO 下个版本可以考虑取消这个配置，目前来看除了notLastLine支持之外没区别
        if (this.config.keepLastLine === false && lastChild && !lastChild.type.isAtom)
            return;
        if (!shouldInsertParagraph(lastChild))
            return;
        var marks = util_1.Utils.getStoreMarks(state);
        dispatch(tr
            .insert(doc.nodeSize - 2, state.schema.nodes[const_1.NODE_NAME.P].create())
            .ensureMarks(marks)
            .setMeta('addToHistory', false));
    };
    BasicView.prototype.destroy = function () {
        this.dropCursor && this.dropCursor.destroy();
    };
    return BasicView;
}());
exports.BasicView = BasicView;
//# sourceMappingURL=basic-view.js.map